import { LevelThreshold } from '@vae/server/src/services/achievementService/types/levelThreshold'
import { ScriptableContext } from 'chart.js'
import getYValue from './getYValue'

const getPointBorderColor = (ctx: ScriptableContext<'line'>, levelThresholds: LevelThreshold) => {
	const index = ctx.dataIndex
	const rawValue = ctx.dataset.data[index]

	const y = getYValue(rawValue)

	if (y == null || y < levelThresholds.gold) return '#a5a5a5'
	if (y < levelThresholds.platinum) return '#ffb30d'

	return '#d9d9d9'
}

export default getPointBorderColor
